import 'css-chunksrc/feature/check-item/CheckItemPageNewEdit.module.scss';export default {
  "main_root": "CheckItemPageNewEdit_main_root",
  "main_container": "CheckItemPageNewEdit_main_container",
  "main_buttons": "CheckItemPageNewEdit_main_buttons",
  "main_cardScrollContainer": "CheckItemPageNewEdit_main_cardScrollContainer",
  "main_cardsContainer": "CheckItemPageNewEdit_main_cardsContainer"
};